import React from 'react';
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";

import ContainerTranslation from "../partials/ContainerTranslation";
import Select from 'react-select';
import _ from 'lodash';

let common = require('../../assets/translations/common.json');

const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center',
};

const formatGroupLabel = data => (
  <div style={groupStyles}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>
  </div>
);
//TODO react select 2.0.0
class DashboardSearch extends React.Component {


  selectItem = (parent, names,  data  ) => {
    let _this = this
    if(Array.isArray(data)){
      let dataToReturn = []
      if(names){
        _.each(names, function(name){
          dataToReturn.push({
            index: null,
            name: name,
            parent: parent,
            value: [],
          });
        })
      }else{
        dataToReturn.push({
          index: null,
          name: null,
          parent: parent,
          value: [],
        });
      }

      _.each(data, function(d){

        let foundData = _.find(dataToReturn, function(dr){
          if(d.name){
            return dr.name === d.name && dr.parent === d.parent
          }else{
            return dr.parent === d.parent
          }
        })

        if(foundData){
          foundData.value.push(d.value)
        }else{
          dataToReturn.push({
            index:undefined,
            name:d.name,
            parent:d.parent,
            value:[d.value],
          })
        }
      })
      _.each(dataToReturn, function(d){
        _this.props.selectItem(d);
      })
    } else{
      _this.props.selectItem(data);
    }
  }

  getSelectValue(parent, names,  data ){
    return null
  }

  handleSortChange(data) {
    this.props.setSort(data.value);
  }

  handleValidationFilter(data) {
    this.props.selectValidationFilter(data.value);
  }

  render() {
    
    let _this = this;
    let type;
    let initConsultants = _.cloneDeep(this.props.initConsultants);
    let consultantList = [];
    let countryOptions = [];
    let countryDefaultValue = [];

    if(this.props.consultants){
      type = 'country';
      if (initConsultants) {
        consultantList = initConsultants
      };
      
      let options = []
      _.each(consultantList, function(consultant){
        options.push(consultant.user.filiale.country)
      })

      countryOptions.push({
        options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
          if(option){
            return {
              value : option,
              label : option,
              name : null,
              parent : type
            }
          }
        })),'value'))
      })

      _.forEach(_this.props.selectedItems[type], function(option){
        countryDefaultValue.push({
          value : option,
          label : option,
          name : null,
          parent : type
        })
      })

    }

    
    let clientOptions = []
    let clientDefaultValue = []
    if(this.props.consultants){
      type = 'clients';
      if (initConsultants) {
        consultantList = initConsultants
      };
      let options = []
      _.each(consultantList, function(consultant){
        _.each(consultant.projects, function(project){
          if (project.content.client.level_1){
            options.push(project.content.client.level_1.value)
          }
        })
      })

      

      clientOptions.push({
        options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
          if(option){
            return {
              value : option,
              label : option,
              name : null,
              parent : type
            }
          }
        })),'value'))
      })
      _.forEach(_this.props.selectedItems[type], function(option){
        clientDefaultValue.push({
          value : option,
          label : option,
          name : null,
          parent : type
        })
      })

    }

    
    let seniorityOptions = []
    let seniorityDefaultValue = []
    
    if(this.props.consultants){
      type = 'seniority';
      if (initConsultants) {
        consultantList = initConsultants
      };
      let options = []
      _.each(consultantList, function(consultant){
        options.push(consultant.seniority)
      })
      seniorityOptions.push({
        options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
          if(option){
            return {
              value : option,
              label : option,
              name : null,
              parent : type
            }
          }
        })),'value'))
      })
      _.forEach(_this.props.selectedItems[type], function(option){
        seniorityDefaultValue.push({
          value : option,
          label : option,
          name : null,
          parent : type
        })
      })

    }


    let environnementOptions = []
    let environnementData = ['environnement-domain', 'environnement-context']
    let environnementDefaultValue = []
    
    if(this.props.consultants){
      type = 'environnement';
      consultantList = _this.props.consultants
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants
      };
      _.each(environnementData, function(data){
        let options = []
        _.each(consultantList, function(consultant){
          if(consultant && consultant.content){
            let domain = Object.keys(consultant.content.environnement[data])
            if(data==="environnement-context"){
              domain.forEach((names) => {
                let context = Object.keys(consultant.content.environnement[data][names])
                context.forEach((name) => {
                  options.push(name)
                })
              });
            } else {
              domain.forEach((name) => {
                options.push(name)
              });
            }
          }
        })

        environnementOptions.push({
          label: _this.props.translate("Filters-labels."+ [common.content[type][data].title[0]]),
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
            if(option){
              return {
                value : option,
                label : _this.props.translate(['context'] +"." + [option]),
                name : data,
                parent : type
              }
            }
          })),'value'))
        })
        _.forEach(_this.props.selectedItems[type][data], function(option){
          environnementDefaultValue.push({
            value : option,
            label : _this.props.translate(['context'] +"." + [option]),
            name : data,
            parent : type
          })
        })
      })
    }
    

    let expertiseOptions = []
    let expertiseData = ['domain-competence', 'domain-speciality', 'domain-specificity']
    let expertiseDefaultValue = []
    if(this.props.consultants){
      type = 'expertise';
      consultantList = _this.props.consultants
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants
      };
      _.each(expertiseData, function(data){
        let options = []
        let category = common.content[type][data].title[0]
        _.each(consultantList, function(consultant){
          _.each(consultant.content[type], function(item){
            let obj = item
            obj.name  = item[data]
            if (category === "Technical competence") {
              obj.label = _this.props.translate(['domain-competence'] +"." + item['domain-competence'])
            }
            if (category === "Technical specialty") {
              obj.label = _this.props.translate(['domain-speciality'] +"." + item['domain-competence']+"." + item['domain-speciality'])
            }
            if (category === "Technical specificity") {
              obj.label = _this.props.translate(['domain-specificity'] +"." + item['domain-speciality'] +"." + item['domain-specificity'])
            }
            options.push(obj)
          })
        })

        expertiseOptions.push({
          label: _this.props.translate(['domain-label'] +"." + [category]),
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
            if(option.name){
              return {
                value : option.name,
                label : option.label ? option.label : option.name,
                name : data,
                parent : type
              }
            }
          })),'value'))
        })
        _.forEach(_this.props.selectedItems[type][data], function(option){
          expertiseDefaultValue.push({
            value : option.name,
            label : option.label ? option.label : option.name,
            name : data,
            parent : type
          })
        })
      })
    }

    let interventionLevelOptions = []
    let interventionLevelData = ['intervention-type', 'intervention-mission', 'intervention-application']
    let interventionLevelDefaultValue = []
    if(this.props.consultants){
      type = 'intervention-level';
      consultantList = _this.props.consultants
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants
      };
      _.each(interventionLevelData, function(data){
        let options = []
        let category  = common.content[type][data].title[0]
        _.each(consultantList, function(consultant){
          _.each(consultant.content[type], function(item){
            let obj = item
              obj.name  = item[data]
              if (category === "Skill") {
                obj.label = _this.props.translate(['intervention-type'] +"." + item['intervention-type'])
              }
              if (category === "Mission") {
                obj.label = _this.props.translate(['intervention-mission'] +"." + item['intervention-type']+"." + item['intervention-mission'])
              }
              if (category === "Application") {
                obj.label = _this.props.translate(['intervention-application'] +"." + item['intervention-mission'] +"." + item['intervention-application'])
              }
              options.push(obj)
          })
        })
        interventionLevelOptions.push({
          label: _this.props.translate(['intervention-label']+ "." + category),
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){

            if(option.name){
              return {
                value : option.name,
                label : option.label ? option.label : option.name,
                name : data,
                parent : type
              }
            }
          })),'value'))
        })
        _.forEach(_this.props.selectedItems[type][data], function(option){
          interventionLevelDefaultValue.push({
            value : option.name,
            label : option.label ? option.label : option.name,
            name : data,
            parent : type
          })
        })
      })
    }

    let engineeringOptions = []
    let engineeringData = ['engineering-skill', 'engineering-specialization' ]
    let engineeringDefaultValue = []
    if(this.props.consultants) {
      type = 'engineering';
      consultantList = _this.props.consultants
      if (this.props.filtersByOr.find(item => item === type)) {
        consultantList = initConsultants
      };
      _.each(engineeringData, function(data){
        let options = []
        let category  = common.content[type][data].title[0];
        _.each(consultantList, function(consultant){
          _.each(consultant.content[type], function(item){
            let obj = item
            obj.name  = item[data];
            if (category === "Skill") {
              obj.label = _this.props.translate(['engineering-skill'] +"." + item['engineering-skill'])
            }
            if (category === "Engineering specialization") {
              obj.label = _this.props.translate(['engineering-specialization'] +"." + item['engineering-skill'] +"." + item['engineering-specialization'])
            }
            options.push(obj)
          })
        })
        engineeringOptions.push({
          label: _this.props.translate("content.engineering." + [data] + ".title") ,
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
            if(option.name){
              return {
                value : option.name,
                label : option.label ? option.label : option.name,
                name : data,
                parent : type
              }
            }
          })),'value'))
        })
        _.forEach(_this.props.selectedItems[type][data], function(option){
          engineeringDefaultValue.push({
            value : option.name,
            label : option.label ? option.label : option.name,
            name : data,
            parent : type
          })
        })
      })
    }






    return (
      <div className="formulaires">
        <div className="formulaire-section" style={{width:'100%'}}>

          <div className={"formulaire wide"}>
            <div className={"formulaire-field select"}>
              {/*country*/}
              <div className={"inline"} style={{width:'calc(33.33% - 10px)'}}>
                <div className="input-container">
                  <label>
                    {this.props.translate("user.Country.title")}
                  </label>
                  <div className="switch-container">
                    <label className="switch" htmlFor="tools">
                      <input
                        type="checkbox"
                        id="country"
                        name="country"
                        onChange={() => this.props.setFilterByOr("country")}
                        checked={this.props.filtersByOr.find(item => item === "country") ? true : false }/>
                      <div className="slider round"></div>
                    </label>
                    {this.props.filtersByOr.find(item => item === "country") ? <p><ContainerTranslation id={'Filters-labels.' + ['add-to-select']} tag={"span"}/></p> : <p><ContainerTranslation id={'Filters-labels.' + ['combine-to-select']} tag={"span"}/></p> }
                  </div>
                  <Select
                    className={'react-select-container'}
                    classNamePrefix="react-select"
                    options={countryOptions}
                    isClearable={true}
                    formatGroupLabel={formatGroupLabel}
                    isMulti={true}
                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                    onChange={this.selectItem.bind(this, 'country', null)}
                    defaultValue={countryDefaultValue}
                  />
                </div>
              </div>

              {/*CLIENTS*/}
              <div className={"inline"} style={{width:'calc(33.33% - 10px)', marginLeft:'15px'}}>
                <div className="input-container">
                  <label>
                    {this.props.translate("content.client.title")}
                  </label>
                  <div className="switch-container">
                    <label className="switch" htmlFor="tools">
                      <input
                        type="checkbox"
                        id="clients"
                        name="clients"
                        onChange={() => this.props.setFilterByOr("clients")}
                        checked={this.props.filtersByOr.find(item => item === "clients") ? true : false }/>
                      <div className="slider round"></div>
                    </label>
                    {this.props.filtersByOr.find(item => item === "clients") ? <p><ContainerTranslation id={'Filters-labels.' + ['add-to-select']} tag={"span"}/></p> : <p><ContainerTranslation id={'Filters-labels.' + ['combine-to-select']} tag={"span"}/></p> }
                  </div>
                  <Select
                    className={'react-select-container'}
                    classNamePrefix="react-select"
                    options={clientOptions}
                    isClearable={true}
                    formatGroupLabel={formatGroupLabel}
                    isMulti={true}
                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                    onChange={this.selectItem.bind(this, 'clients', null)}
                    defaultValue={clientDefaultValue}
                  />
                </div>
              </div>

              {/*Seniority*/}
              <div className={"inline"} style={{width:'calc(33.33% - 10px)', marginLeft:'15px'}}>
                <div className="input-container">
                  <label>
                    {this.props.translate("content.extract.dashboard.chart.experience")}
                  </label>
                  <div className="switch-container">
                    <label className="switch" htmlFor="tools">
                      <input
                        type="checkbox"
                        id="seniority"
                        name="seniority"
                        onChange={() => this.props.setFilterByOr("seniority")}
                        checked={this.props.filtersByOr.find(item => item === "seniority") ? true : false }/>
                      <div className="slider round"></div>
                    </label>
                    {this.props.filtersByOr.find(item => item === "seniority") ? <p><ContainerTranslation id={'Filters-labels.' + ['add-to-select']} tag={"span"}/></p> : <p><ContainerTranslation id={'Filters-labels.' + ['combine-to-select']} tag={"span"}/></p> }
                  </div>
                  <Select
                    className={'react-select-container'}
                    classNamePrefix="react-select"
                    options={seniorityOptions}
                    isClearable={true}
                    formatGroupLabel={formatGroupLabel}
                    isMulti={true}
                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                    onChange={this.selectItem.bind(this, 'seniority', null)}
                    defaultValue={seniorityDefaultValue}
                  />
                </div>
              </div>

            </div>

            <div className={"formulaire-field select"}>
              
                {/*INTERVENTION LEVEL*/}
                <div className={"inline"} style={{width:'calc(33.33% - 10px)'}}>
                  <label>
                    <ContainerTranslation id={"content."+['intervention-level']+".title"} tag={"span"}/>
                  </label>
                  <div className="switch-container">
                    <label className="switch" htmlFor="intervention-level">
                      <input
                        type="checkbox"
                        id="intervention-level"
                        name="intervention-level"
                        onChange={() => this.props.setFilterByOr("intervention-level")}
                        checked={this.props.filtersByOr.find(item => item === "intervention-level") ? true : false }/>
                      <div className="slider round"></div>
                    </label>
                    {this.props.filtersByOr.find(item => item === "intervention-level") ? <p><ContainerTranslation id={'Filters-labels.' + ['add-to-select']} tag={"span"}/></p> : <p><ContainerTranslation id={'Filters-labels.' + ['combine-to-select']} tag={"span"}/></p> }
                  </div>
                  <Select
                    className={'react-select-container'}
                    classNamePrefix="react-select"
                    isClearable={true}
                    options={interventionLevelOptions}
                    formatGroupLabel={formatGroupLabel}
                    isMulti={true}
                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                    onChange={this.selectItem.bind(this, 'intervention-level', interventionLevelData)}
                    defaultValue={interventionLevelDefaultValue}
                  />
                </div>

                {/*ENVIRONNEMENT*/}
                <div className={"inline"} style={{width:'calc(33.33% - 10px)',marginLeft:'15px'}}>
                  <div className="input-container">
                    <label>
                      <ContainerTranslation id={"content."+['environnement']+".title"} tag={"span"}/>
                    </label>
                    <div className="switch-container">
                      <label className="switch" htmlFor="environnement">
                        <input
                          type="checkbox"
                          id="environnement"
                          name="environnement"
                          onChange={() => this.props.setFilterByOr("environnement")}
                          checked={this.props.filtersByOr.find(item => item === "environnement") ? true : false }/>
                        <div className="slider round"></div>
                      </label>
                      {this.props.filtersByOr.find(item => item === "environnement") ? <p><ContainerTranslation id={'Filters-labels.' + ['add-to-select']} tag={"span"}/></p> : <p><ContainerTranslation id={'Filters-labels.' + ['combine-to-select']} tag={"span"}/></p> }
                    </div>
                    <Select
                      className={'react-select-container'}
                      classNamePrefix="react-select"
                      options={environnementOptions}
                      formatGroupLabel={formatGroupLabel}
                      isMulti={true}
                      placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                      onChange={this.selectItem.bind(this, 'environnement', environnementData)}
                      defaultValue={environnementDefaultValue}
                    />
                  </div>
                </div>

                {/*EXPERTISE*/}
                <div className={"inline"} style={{width:'calc(33.33% - 10px)',marginLeft:'15px'}}>
                  <label>
                    <ContainerTranslation id={"content."+['expertise']+".title"} tag={"span"}/>
                  </label>
                  <div className="switch-container">
                    <label className="switch" htmlFor="expertise">
                      <input
                        type="checkbox"
                        id="expertise"
                        name="expertise"
                        onChange={() => this.props.setFilterByOr("expertise")}
                        checked={this.props.filtersByOr.find(item => item === "expertise") ? true : false }/>
                      <div className="slider round"></div>
                    </label>
                    {this.props.filtersByOr.find(item => item === "expertise") ? <p><ContainerTranslation id={'Filters-labels.' + ['add-to-select']} tag={"span"}/></p> : <p><ContainerTranslation id={'Filters-labels.' + ['combine-to-select']} tag={"span"}/></p> }
                  </div>
                  <Select
                    className={'react-select-container'}
                    classNamePrefix="react-select"
                    options={expertiseOptions}
                    formatGroupLabel={formatGroupLabel}
                    isClearable={true}
                    isMulti={true}
                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                    onChange={this.selectItem.bind(this, 'expertise', expertiseData)}
                    defaultValue={expertiseDefaultValue}
                  />
                </div>
            </div>
        </div>
      </div>
    </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps, {})(withLocalize(DashboardSearch));
